import ApiClient from "../api";
import { processV2Response } from "../api/utils/api";
import USER from "../types/User";

export const resetPasswordReceive = (data) => {
  return {
    type: USER.RESET_PASSWORD_RECEIVE,
    token: data.token,
  };
};

export const resetPasswordFailure = (errors) => {
  return {
    type: USER.RESET_PASSWORD_FAILURE,
    errors: { resetPassword: errors },
  };
};

export const resetPasswordRequest = ({ password, token }) => {
  return (dispatch) => {
    dispatch({ type: USER.RESET_PASSWORD_REQUEST });
    return ApiClient.get()
      .resetPassword({ password, token })
      .then((res) =>
        dispatch(
          processV2Response(res, resetPasswordReceive, resetPasswordFailure)
        )
      );
  };
};

export const emailSignupReceive = ({ payload }) => {
  return {
    type: USER.EMAIL_SIGNUP_RECEIVE,
    payload,
  };
};

export const emailSignupFailure = (errors) => {
  return {
    type: USER.EMAIL_SIGNUP_FAILURE,
    errors: { newsletterSignup: errors },
  };
};

export const emailSignupRequest = ({ email, ageContentTypes }) => {
  return (dispatch) => {
    dispatch({ type: USER.EMAIL_SIGNUP_REQUEST });
    return ApiClient.get()
      .emailSignup({ email, ageContentTypes })
      .then((res) =>
        dispatch(processV2Response(res, emailSignupReceive, emailSignupFailure))
      );
  };
};

export const hatchForWorkSignupReceive = ({ payload }) => {
  return {
    type: USER.HATCH_FOR_WORK_SIGNUP_RECEIVE,
    payload,
  };
};

export const hatchForWorkSignupFailure = (errors) => {
  return {
    type: USER.HATCH_FOR_WORK_SIGNUP_FAILURE,
    errors: { hatchForWorkSignup: errors },
  };
};

export const hatchForWorkSignupRequest = (data) => {
  return (dispatch) => {
    dispatch({ type: USER.HATCH_FOR_WORK_SIGNUP_REQUEST });
    return ApiClient.get()
      .hatchForWorkSignup(data)
      .then((res) =>
        dispatch(
          processV2Response(
            res,
            hatchForWorkSignupReceive,
            hatchForWorkSignupFailure
          )
        )
      );
  };
};
